import { AiOutlineUpload, AiOutlineCloseSquare, AiOutlineSearch, AiOutlineCheckSquare, AiOutlineEdit } from "react-icons/ai";
import "react-multi-date-picker/styles/colors/red.css";
import EditModal from "./EditModal";
export default function RowComponent({ index, contract, addEditContract }) {
  const unixToPersianDate = (unix) => {
    let options = { year: "numeric", month: "numeric", day: "numeric" };
    let date = new Date(parseInt(unix) * 1000).toLocaleDateString("fa-IR", options);
    date.replace(/([۰-۹])/g, (token) => String.fromCharCode(token.charCodeAt(0) - 1728));
    return date;
  };

  return (
    <>
      <EditModal index={index} contract={contract} addEditContract={addEditContract}></EditModal>
      <tr>
        <th scope="row">{index}</th>
        <td>{contract.senfcode}</td>
        <td> {contract.agentfullname}</td>
        <td>{contract.agencyname}</td>
        <td>{contract.agencytell}</td>
        <td>{contract.agencymob}</td>

        <td>{contract.agentmainmob}</td>
        <td>{unixToPersianDate(contract.expiredate)}</td>

        <td>{unixToPersianDate(contract.registerdate)}</td>
        <td>{contract.sms_request_count}</td>

        {parseInt(contract.agency_state) ? (
          <td className="active-icon contract-icon">
            <AiOutlineCheckSquare></AiOutlineCheckSquare>
          </td>
        ) : (
          <td className="disable-icon contract-icon">
            <AiOutlineCloseSquare></AiOutlineCloseSquare>
          </td>
        )}
        {parseInt(contract.subscribtion_state) ? (
          <td className="active-icon contract-icon">
            <AiOutlineCheckSquare></AiOutlineCheckSquare>
          </td>
        ) : (
          <td className="disable-icon contract-icon">
            <AiOutlineCloseSquare></AiOutlineCloseSquare>
          </td>
        )}

        <td>{contract.lastsmsdate}</td>

        <td className="contract-icon">
          <div style={{ cursor: "pointer" }} data-bs-target={`#edit-contract-${index}`} data-bs-toggle="modal">
            <AiOutlineEdit></AiOutlineEdit>
          </div>
        </td>
      </tr>
    </>
  );
}
